<template>
  <Modal
    :close-on-outside-click="false"
    :closable="true"
    :show-footer="false"
    :show="isOptionsModalOpen"
    @close="closeOptionsModal"
  >
    <template #header>Can we count on your continuing support?</template>
    <template #body>
      <div class="monthly__modal__desc">
        <p>
          <img
            src="https://res.cloudinary.com/ncsy/image/upload/c_scale,f_auto,q_auto,w_500/v1667306487/bikepr/logos/wesctoast1.png"
            alt="westcoast image"
          />
        </p>
        <p>
          Please consider joining our monthly giving community. Your ongoing commitment to
          our teens supercharges the Jewish future and makes our work sustainable - thank
          you!
        </p>
        <!-- <p>
          <strong
            >Before we process your one-time gift, will you consider converting it into a
            smaller monthly gift of ${{ form.amount }} instead?</strong
          >
        </p> -->
      </div>

      <div class="styled-radio-container styled-radio-container--ou-donation">
        <div class="radio-part">
          <input
            id="monthsly"
            type="radio"
            class="frequency"
            :checked="monthly"
            @click="
              setValue('amount', '75'),
                setValue('dayOfMonth', '' + new Date().getDate()),
                closeOptionsModal()
            "
          />
          <FormLabel for="monthsly">Yes! Change my gift to $75 a month</FormLabel>
        </div>
        <div class="radio-part">
          <input
            id="onesTime"
            type="radio"
            class="frequency"
            :checked="!monthly"
            @click="setValue('dayOfMonth', null), closeOptionsModal()"
          />
          <FormLabel for="onesTime"
            >No thanks, complete my one-time of gift of ${{ form.amount }} only</FormLabel
          >
        </div>
      </div>
      <FormRow class="monthly-note" v-if="monthly && showMsg">
        <div>
          Your donation will be made today and on the <strong>{{ monthDay }}</strong> of
          each following month using the payment method selected. You may change or cancel
          this amount at any time. <br /><br />
        </div>
      </FormRow>
    </template>
  </Modal>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  props: {
    showMsg: {
      type: Boolean,
      default: true,
    },
  },
  setup(_, { emit }) {
    const { setValue, form, getValue } = usePaymentForm();
    const modalOpen = ref(true);

    const selectedAmount = ref(form.value.amount);
    const isOptionsModalOpen = ref(true);
    const openOptionsModal = () => {
      isOptionsModalOpen.value = true;
    };
    const closeOptionsModal = () => {
      isOptionsModalOpen.value = false;
      emit("close");
    };

    return {
      form,
      selectedAmount,
      monthly: computed(() => !!form.value.dayOfMonth),
      getValue,
      setValue,
      monthDay: computed(() => {
        const i = +form.value.dayOfMonth!;

        const j = i % 10,
          k = i % 100;
        if (j == 1 && k != 11) {
          return i + "st";
        }
        if (j == 2 && k != 12) {
          return i + "nd";
        }
        if (j == 3 && k != 13) {
          return i + "rd";
        }
        return i + "th";
      }),
      modalOpen,
      isOptionsModalOpen,
      openOptionsModal,
      closeOptionsModal,
    };
  },
});
</script>
<style scoped lang="scss">
.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;

  .month-limit {
    margin-right: 20px;
    min-width: 110px;
  }
}
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0px 0 15px 0px;
  width: 100%;
  padding-top: 4px;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      margin-bottom: 10px;
    }
  }
  input[type="radio"] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type="radio"]:checked + label {
    background: #1aa8d3;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
}

.monthly__modal {
  background: #f2f5f8;
  padding: 25px 20px;
  border-radius: 4px;
  line-height: 1.4;
  font-size: 15px;
}
.monthly__modal__desc {
  p {
    margin-bottom: 14px;
  }
}
::v-deep .modal-header {
  line-height: 1.4;
  font-weight: 600;
}

// .monthly__wrapper {
//   position: fixed;
//   right: 0px;
//   left: 0px;
//   bottom: 40px;
//   width: 100%;
//   background: white;
//   padding: 0px;
//   box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
//   height: fit-content;
//   max-width: 525px;
//   margin: 25px auto;
//   z-index: 10003;
//   top: 40px;
//   border-radius: 3px;
// }

// .monthly__wrapper {
//   position: fixed;
//   right: 0px;
//   left: 0px;
//   bottom: 40px;
//   width: 100%;
//   background: white;
//   padding: 0px;
//   box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
//   height: fit-content;
//   max-width: 525px;
//   margin: 25px auto;
//   z-index: 10003;
//   top: 40px;
//   border-radius: 3px;
// }
// .monthly__body {
//   background: rgba(128, 128, 128, 0.6);
//   position: fixed;
//   top: 0px;
//   left: 0px;
//   right: 0px;
//   bottom: 0px;
//   top: 0px;
//   width: 100%;
//   height: 100%;
//   z-index: 9999999;
//   display: none;
//   &.monthly__open {
//     display: block;
//   }
// }

::v-deep .modal {
  max-width: 525px;
  line-height: 1.4;
}
</style>
